import { API_URL } from "./apiHelper";

import axios from "axios";
export const authService = {
  login: async (email,password) => {
    const response = await axios.post(`${API_URL}/v1/auth/login`, {
      email,
      password,
    }); 

    return response.data; 
  },

  getCurrentUser: async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));

    // For demo, always return admin user when token exists
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }

    return [];
  },  
 

  forgotPassword: async (email)=> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    
  },
};